<!-- 看图说话 游戏配置—— 使用模块有：(单词，自然拼读) -->
<template>
  <el-form ref="ref_form" :model="interferenceForm" :rules="rules" label-width="100px">
    <div v-for="(item, index) in interferenceForm.dataList" :key="index" class="game-cutline">
      <el-form-item :label="'学习内容' + (index + 1)">
        <el-input v-model="item.wordName" disabled style="width: 350px;" />
      </el-form-item>
      <el-form-item label="问题音频" :prop="'dataList.' + index + '.voice'" :rules="rules.voice">
        <themeUploadList style="width: 350px;" code="customVoice" :file-list.sync="item.voice" accept=".mp3,.wmv" :limit="1" tip="仅支持.mp3文件" />
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
import themeUploadList from '../../components/themeUploadList'
// import uploadList from '@/components/Upload/uploadList.vue'
// import { getDictoryInfoByCode } from '@/api/api_common.js'
import { saveConfData } from '@api/courseManagement/api_quiz'
export default {
  components: {
    themeUploadList
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    currentQuizType: {
      type: String,
      default: ''
    },
    gameList: {
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    interferenceList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      interferenceForm: {
        dataList: []
      },
      rules: {
        wordName: [{ required: true, message: '请输入', trigger: 'blur' }],
        voice: [{ type: 'array', required: false, message: '请上传问题音频', trigger: 'change' }]
      }

    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive'])
  },
  watch: {
    gameList: function (val) {
      this.interferenceForm.dataList = []
      for (const item of this.gameList) {
        const name = item.questionMeans ? item.questionMeans.pronunciationName : ''
        const fileName = item.questionMeans ? item.questionMeans.pronunciationFileName : ''
        const paramsUrl = item.questionMeans ? item.questionMeans.pronunciationPath : ''
        const voice = item.questionMeans ? [{ name: fileName, paramsFileName: name, paramsUrl: paramsUrl, url: paramsUrl }] : []
        this.interferenceForm.dataList.push({ state: item.state, studyId: item.studyId, wordName: item.wordName, questionMeans: {}, voice: voice })
      }
    }
  },

  created () {

  },
  methods: {
    getOptions () {

      // getDictoryInfoByCode ('').then(res => {  })
    },

    imgClick (item) {
      this.currentWord = item
    },
    // 保存游戏配置项
    saveGameOptions() {
      this.$refs.ref_form.validate(valid => {
        if (!valid) { return false }
        this.interferenceForm.dataList.forEach(item => {
          if (item.voice[0]) {
            item.questionMeans.pronunciationName = item.voice[0].paramsFileName
            item.questionMeans.pronunciationPath = item.voice[0].paramsUrl
          } else {
            item.questionMeans = null
          }
        })
        const params = {
          curriculumId: this.courseData.teachingCurriculumId,
          curriculumType: this.courseData.curriculumType,
          quizType: this.currentQuizType,

          items: this.interferenceForm.dataList
        }
        saveConfData(params).then(res => {
          this.$message.success('操作成功')
          this.$emit('finishSave')
        })
      })
    }
  }
}
</script>

<style lang='scss'>

</style>
